import { fetchQuery_DEPRECATED as fetchQuery } from 'react-relay/legacy';
import get from 'lodash/get';
import { getBuyerId } from 'dibs-cookie-jar';
import { tradeVerifyFirmReminderQuery } from './tradeVerifyFirmReminderQuery';
import { showTradeVerifyFirmReminder } from './showTradeVerifyFirmReminder';
import { canShowTradeVerifyFirmReminderToast } from '../../../TradeVerifyFirmReminderToast/toastHelpers';
import { TABLET, DESKTOP } from '../../../../exports/deviceTypeEnums';

const tradeVerifyFirmReminderRule = ({ relayEnvironment }) => {
    if (canShowTradeVerifyFirmReminderToast()) {
        const userId = getBuyerId(document.cookie);
        return fetchQuery(relayEnvironment, tradeVerifyFirmReminderQuery, { userId }).then(
            response =>
                get(response, 'viewer.user.verifiedTradeStatus') ===
                'APPLIED_NOT_ENOUGH_INFORMATION'
        );
    }
    return Promise.resolve(false);
};

export const tradeVerifyFirmReminderConfig = {
    name: 'tradeVerifyFirmReminder',
    rule: tradeVerifyFirmReminderRule,
    deviceTypes: [TABLET, DESKTOP],
    action: showTradeVerifyFirmReminder,
    priority: 455,
};
